import SubscriptionType from '@/generated/classes/SubscriptionType';
import { SubscriptionRequired as SubscriptionRequiredBase } from '@/generated/classes/SubscriptionType';
export default class SubscriptionTypeExtend extends SubscriptionType {
  constructor() {
    super();
  }
}
export class SubscriptionRequired extends SubscriptionRequiredBase {
  constructor() {
    super();
  }
}
